import { ReactElement } from 'react';
import { FaqMain } from '../../../types/puppyGuide';
import { StarterArticles, StarterArticleSource } from '../../../types/StarterGuideTypes';
import { BLOG_ASSET_URL, BLOG_URL, PET_MD_ASSET_URL, PET_MD_URL } from '../../../util/config';
// Intros
import { content as mainIntro } from './intro/mainIntro';
import { content as healthAndGroomingIntro } from './intro/healthAndGroomingIntro';
import { content as foodAndNutritionIntro } from './intro/foodAndNutritionIntro';
import { content as trainingAndBehavior } from './intro/trainingAndBehaviorIntro';
import { content as toysAndHomeGoodsIntro } from './intro/toysAndHomeGoodsIntro';
//FAQs
import { faq as healthAndGroomingFAQ } from './faq/healthAndGroomingFAQ';
import { faq as foodAndNutritionFAQ } from './faq/foodAndNutritionFAQ';
import { faq as trainingAndBehaviorFAQ } from './faq/trainingAndBehaviorFAQ';
import { faq as toysAndHomeGoodsFAQ } from './faq/toysAndHomeGoodsFAQ';
// Articles
import { articles as healthAndGroomingArticles } from './articles/healthAndGroomingArticles';
import { articles as foodAndNutritionArticles } from './articles/foodAndNutritionArticles';
import { articles as trainingAndBehaviorArticles } from './articles/trainingAndBehaviorArticles';
import { articles as toysAndHomeGoodsArticles } from './articles/toysAndHomeGoodsArticles';

export const getMainIntro = (): ReactElement => mainIntro;

export const getIntro = (sectionNumber: number): ReactElement | null => {
  switch (sectionNumber) {
    case 1:
      return healthAndGroomingIntro;
    case 2:
      return foodAndNutritionIntro;
    case 3:
      return trainingAndBehavior;
    case 4:
      return toysAndHomeGoodsIntro;
    default:
      return null;
  }
};

export const getFAQ = (sectionNumber: number): FaqMain | null => {
  switch (sectionNumber) {
    case 1:
      return healthAndGroomingFAQ;
    case 2:
      return foodAndNutritionFAQ;
    case 3:
      return trainingAndBehaviorFAQ;
    case 4:
      return toysAndHomeGoodsFAQ;
    default:
      return null;
  }
};

export const getArticleLink = (link: string, source: StarterArticleSource): string => {
  if (source === StarterArticleSource.BE_CHEWY) {
    return BLOG_URL + link;
  } else if (source === StarterArticleSource.PET_MD) {
    return PET_MD_URL + link;
  }
  return '';
};

export const getArticleImageLink = (link: string, source: StarterArticleSource): string => {
  if (source === StarterArticleSource.BE_CHEWY) {
    return BLOG_ASSET_URL + link;
  } else if (source === StarterArticleSource.PET_MD) {
    return PET_MD_ASSET_URL + link;
  }
  return '';
};

export const getArticles = (sectionNumber: number): StarterArticles | null => {
  switch (sectionNumber) {
    case 1:
      return healthAndGroomingArticles;
    case 2:
      return foodAndNutritionArticles;
    case 3:
      return trainingAndBehaviorArticles;
    case 4:
      return toysAndHomeGoodsArticles;
    default:
      return null;
  }
};
